import useGetApi from "../useGetApi"
import useMutateApi from "../useMutateApi"

// constants
import apiEndpoints from "api/utils/apiEndpoints"
import queryKeys from "api/utils/queryKeys"

// utils
import getUrl from "api/apiMap"

export const useGetAllReports = () => {
  return useGetApi(`${getUrl(apiEndpoints.reports)}`, queryKeys.reports.all)
}

export const useGetHandleReport = (model) => {
  return useGetApi(
    model ? `${getUrl(apiEndpoints.reportRegen)}?report_model=${model}` : null,
    queryKeys.reports.regen(model)
  )
}

export const usePostHandleReport = (model, infoMsg = "Regenerating report") => {
  return useMutateApi({
    method: "post",
    apiEndpoint: `${getUrl(apiEndpoints.reportRegen)}`,
    invalidateQueries: [queryKeys.reports.regen(model)],
    infoMsg,
  })
}

export const useGetReport = (type) => {
  return useMutateApi({
    method: "post",
    apiEndpoint: `${getUrl(apiEndpoints.reports)}${type}/`,
    invalidateQueries: [queryKeys.reports.type(type)], // TODO: limit to just study queries?
    successMsg: "Successfully subscribed to report",
  })
}

export const usePostExportReport = (type) => {
  return useMutateApi({
    method: "post",
    apiEndpoint: `${getUrl(apiEndpoints.exportReport)}`,
    invalidateQueries: [queryKeys.reports.export(type)], // TODO: review - why need to invalidate queries?
    infoMsg: "Generating your report. This may take a few minutes.",
  })
}
